import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Switch from '@ls/react-switch';
import { selectSelectedReplaceMajorsWithMinors } from 'state/selections/selectors';
import SelectionState from 'state/selections/SelectionState';
import { setReplaceMajorsWithMinors } from 'state/selections/actions';

const ReplaceMajorsWithMinorsSwitch = props => {
  const dispatch = useDispatch();
  const checked = useSelector(
    selectSelectedReplaceMajorsWithMinors(SelectionState.UNCOMMITTED)
  );

  const onChange = React.useCallback(
    replaceMajorsWithMinors => dispatch(setReplaceMajorsWithMinors(replaceMajorsWithMinors)),
    [dispatch]
  );

  return <Switch label="Replace Majors With Minors" 
                 value={checked} 
                 onChange={onChange}
                 raised
        />;
};

ReplaceMajorsWithMinorsSwitch.propsTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ReplaceMajorsWithMinorsSwitch;
